import { AppRoleInfo } from 'src/types';
import { getPlatformFlagName, getRoleFlagName } from './featureFlagConstants';

export const shouldHidePlatform = (
  platformName: string,
  isEnabled: (flagName: string) => boolean
): boolean => {
  const flagName = getPlatformFlagName(platformName);
  return isEnabled(flagName);
};

export const filterHiddenPlatforms = (
  platformName: string,
  isEnabled: (flagName: string) => boolean
): boolean => {
  return !shouldHidePlatform(platformName, isEnabled);
};

export const filterEmptyRoles = (
  isEnabled: (flagName: string) => boolean
): ((appRole: AppRoleInfo) => boolean) => {
  return (appRole: AppRoleInfo) => {
    return (
      appRole.roles.length > 0 &&
      filterHiddenPlatforms(appRole.platform, isEnabled)
    );
  };
};

export const shouldHideRole = (
  roleName: string,
  isEnabled: (flagName: string) => boolean
): boolean => {
  const flagName = getRoleFlagName(roleName);
  return isEnabled(flagName);
};

export const filterRolesToHide = (
  isEnabled: (flagName: string) => boolean
): ((appRole: AppRoleInfo) => AppRoleInfo) => {
  return (appRole: AppRoleInfo) => {
    return {
      ...appRole,
      expand: true,
      roles: appRole.roles.filter(
        (role) => !shouldHideRole(role.name, isEnabled)
      ),
    };
  };
};
